import React from 'react';
import StarRating from '@/components/ui/StarRating';

const testimonials = [
  {
    id: 'review-t01',
    name: 'Sophie Marchand',
    origin: 'Paris, France',
    avatar: 'SM',
    avatarColor: 'bg-primary',
    apartment: 'Sunset Terrace Suite',
    rating: 5,
    text: 'Absolutely magical stay. The terrace views at sunset are unlike anything we\'ve experienced. Maria was incredibly responsive and had local restaurant tips ready for us.',
    date: 'April 2026',
  },
  {
    id: 'review-t02',
    name: 'Lars Eriksson',
    origin: 'Stockholm, Sweden',
    avatar: 'LE',
    avatarColor: 'bg-secondary',
    apartment: 'Rooftop Haven',
    rating: 5,
    text: 'The rooftop is breathtaking. We watched the sunrise every morning with coffee — it became our holiday ritual. Clean, well-equipped, and exactly as described.',
    date: 'March 2026',
  },
  {
    id: 'review-t03',
    name: 'Giulia Ferretti',
    origin: 'Milan, Italy',
    avatar: 'GF',
    avatarColor: 'bg-accent',
    apartment: 'Garden Villa Escape',
    rating: 5,
    text: 'Perfect for our family of five. The garden and BBQ made evenings so special. Kids loved having their own space. Will absolutely be back next summer.',
    date: 'August 2025',
  },
  {
    id: 'review-t04',
    name: 'James Whitfield',
    origin: 'London, UK',
    avatar: 'JW',
    avatarColor: 'bg-purple-500',
    apartment: 'Ocean Breeze Loft',
    rating: 4.8,
    text: 'Ideal location for a couple\'s getaway. Walked to the beach in 2 minutes. The loft has a really cool industrial-meets-coastal vibe. Highly recommend.',
    date: 'May 2026',
  },
];

export default function TestimonialsStrip() {
  return (
    <section className="py-16 max-w-screen-2xl mx-auto px-6 lg:px-10">
      <div className="text-center mb-10">
        <p className="text-xs font-700 uppercase tracking-widest text-primary mb-2">Guest Reviews</p>
        <h2 className="text-hero-md font-800 text-foreground">What Our Guests Say</h2>
        <p className="text-muted-foreground mt-2 text-sm">200+ stays · 4.9 average rating across all apartments</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
        {testimonials?.map((t) => (
          <div key={t?.id} className="card-base p-5 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-full ${t?.avatarColor} text-white flex items-center justify-center text-sm font-700 shrink-0`}>
                {t?.avatar}
              </div>
              <div className="min-w-0">
                <p className="font-700 text-sm text-foreground truncate">{t?.name}</p>
                <p className="text-xs text-muted-foreground truncate">{t?.origin}</p>
              </div>
            </div>
            <div>
              <div className="flex items-center gap-2 mb-2">
                <StarRating rating={t?.rating} size={13} />
                <span className="text-xs text-muted-foreground">{t?.apartment}</span>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed line-clamp-4">{t?.text}</p>
            </div>
            <p className="text-xs text-muted-foreground/60 mt-auto">{t?.date}</p>
          </div>
        ))}
      </div>
    </section>
  );
}